<template>
  <div class="mod-products-wrapper min-h-300">
    <!-- 行李 -->
    <product-item
      type="luggage"
      v-if="hasProduct('luggage') && passenger.passengerType !== 'INF'"
      v-show="isCurrentProduct('luggage')"
      :products="products['luggage']"
      :productBase="productBase['luggage']"
      :value="selectedProducts['luggage'][0]"
      :coupon="{
        enable: false,
        total: getCouponNumber('luggage'),
        value: selectedCoupons['luggage']
      }"
      @select="onProductChange"
      @showCoupon="showCouponList"
    >
      <template v-slot:desc>
        <span
          class="des"
          @click="onShowDesc('luggage')"
        >使用说明</span>
      </template>
      <template v-slot:product="slotProps">
        <div class="info">
          <img
            :src="getAttachImageSrc(`${slotProps.product.services[0].attach}`)"
            :alt="slotProps.product.services[0].productName"
          />
        </div>
      </template>
    </product-item>

    <!-- 餐食 -->
    <product-item
      type="meal"
      v-if="hasProduct('meal') && (passenger.passengerType !== 'INF' || !isFollow)"
      v-show="isCurrentProduct('meal')"
      :products="products['meal']"
      :productBase="productBase['meal']"
      :value="airline === 'JD' ? selectedProducts['meal'] : selectedProducts['meal'][0]"
      :coupon="{
        enable: false,
        total: getCouponNumber('meal'),
        value: selectedCoupons['meal']
      }"
      @select="onProductChange"
      @showCoupon="showCouponList"
    >
      <template v-slot:desc>
        <span
          class="des"
          @click="onShowDesc('meal')"
        >使用说明</span>
      </template>
      <template v-slot:product="slotProps">
        <div class="info">
          <img
            :src="getAttachImageSrc(`${slotProps.product.services[0].attach}`)"
            :alt="slotProps.product.services[0].productName"
          />
        </div>
      </template>
    </product-item>

    <!-- 保险 -->
    <product-item
      type="insurance"
      v-if="hasProduct('insurance') && passenger.passengerType !== 'INF'"
      v-show="isCurrentProduct('insurance')"
      :products="products['insurance']"
      :productBase="productBase['insurance']"
      :value="(ifInternational && airline === 'JD') ? selectedProducts['insurance'][0] : selectedProducts['insurance']"
      :insuranceDes="insuranceDes"
      @select="onProductChange"
    >
      <template v-slot:desc>
        <span class="note">若您自愿变更客票信息，请您登录{{appInfo.name}}官网变更，否则原保险产品将无法保障到您变更后的航班</span>
      </template>
      <template v-slot:product="slotProps">
        <div class="insurance-info">
          <l8-icon
            class="l8-icon icon"
            type="icon-hudun"
          />
          <span class="insurance-info-title">温馨提示</span>
          <div class="insurance-info-main"
            v-if="insuranceDes[slotProps.product?.services?.[0]?.productName]"
          >
            <span class="insurance-info-text" :title="insuranceDes[slotProps.product.services[0].productName].value">{{insuranceDes[slotProps.product.services[0].productName].value}}</span>
            <a class="insurance-info-more red" :href="insuranceDes[slotProps.product.services[0].productName].url" target="_blank">
              {{insuranceDes[slotProps.product.services[0].productName].link}}
          </a>
          </div>
        </div>
      </template>
    </product-item>

    <!-- 行李险 -->
    <product-item
      type="lugInsurance"
      v-if="hasProduct('lugInsurance') && passenger.passengerType !== 'INF'"
      v-show="isCurrentProduct('lugInsurance')"
      :products="products['lugInsurance']"
      :productBase="productBase['lugInsurance']"
      :value="selectedProducts['lugInsurance'][0]"
      :insuranceDes="insuranceDes"
      @select="onProductChange"
    >
      <template v-slot:desc>
      </template>
      <template v-slot:product="slotProps">
        <div class="insurance-info">
          <l8-icon
            class="l8-icon icon"
            type="icon-hudun"
          />
          <span class="insurance-info-title">温馨提示</span>
          <div class="insurance-info-main"
            v-if="insuranceDes[slotProps.product?.services?.[0]?.productName]"
          >
            <span class="insurance-info-text" :title="insuranceDes[slotProps.product.services[0].productName].value">{{insuranceDes[slotProps.product.services[0].productName].value}}</span>
            <a class="insurance-info-more red" :href="insuranceDes[slotProps.product.services[0].productName].url" target="_blank">
              {{insuranceDes[slotProps.product.services[0].productName].link}}
          </a>
          </div>
        </div>
      </template>
    </product-item>

    <!-- 贵宾厅 -->
    <product-item
      type="viphall"
      v-if="hasProduct('viphall') && passenger.passengerType !== 'INF'"
      v-show="isCurrentProduct('viphall')"
      :products="products['viphall']"
      :productBase="productBase['viphall']"
      :value="selectedProducts['viphall'][0]"
      :coupon="{
        enable: false,
        total: getCouponNumber('viphall'),
        value: selectedCoupons['viphall']
      }"
      @select="onProductChange"
      @showCoupon="showCouponList"
    >
      <template v-slot:desc>
        <span
          class="des"
          @click="onShowDesc('guest')"
        >使用说明</span>
      </template>
      <template v-slot:product="slotProps">
        <div class="info">
          <img
            :src="getAttachImageSrc(`${slotProps.product.services[0].attach}`)"
            :alt="slotProps.product.services[0].productName"
          />
        </div>
      </template>
    </product-item>

    <!-- 在线选座 -->
    <!-- NOTE: 为了确保切换旅客能执行选座的渲染逻辑，使用v-show代替v-if -->
    <product-seat
      type="seat"
      v-if="hasProduct('seat')"
      v-show="isCurrentProduct('seat') && passenger.passengerType !== 'INF' && !passenger.hasAccompany"
      :products="products['seat']"
      :productBase="productBase['seat']"
      :value="selectedProducts['seat'][0]"
      :segment="segment"
      :itinerarys="itinerarys"
      :cart="cart"
      :current="current"
      :ifInternational="ifInternational"
      @select="onProductChange"
    >
      <template v-slot:desc>
        <span
          class="des"
          @click="onShowDesc('seat')"
        >使用说明</span>
        <span class="note" style="margin-left: 15px">航班起飞前24小时（含）前可预订，目前仅支持部分航线</span>
      </template>
    </product-seat>

    <!-- 邮寄行程单 -->
    <template v-if="!['JD', 'Y8'].includes(airline)">
      <product-itinerary
        type="itinerary"
        v-if="hasProduct('itinerary')"
        v-show="isCurrentProduct('itinerary')"
        :products="products['itinerary']"
        :productBase="productBase['itinerary']"
        @change="onItineraryChange"
      >
        <template v-slot:desc>
          <span
            class="des"
            @click="onShowDesc('itinerary')"
          >使用说明</span>
        </template>
      </product-itinerary>
    </template>
    <template v-else>
      <product-itinerary-plus
        type="itinerary"
        v-if="hasProduct('itinerary')"
        v-show="isCurrentProduct('itinerary')"
        :products="products['itinerary']"
        :productBase="productBase['itinerary']"
        :ifInternational="ifInternational"
        :isFollow="isFollow"
        @change="onItineraryChange"
      >
        <template v-slot:desc>
          <span
            class="des"
            @click="onShowDesc('itinerary')"
          >使用说明</span>
        </template>
      </product-itinerary-plus>
    </template>

    <div class="product-item product-empty" v-if="isEmpty">
      <l8-icon class="product-empty-icon" type="icon-queshengye-wuxiezuo"></l8-icon>
      <p class="product-empty-text">{{ getProductEmptyText() }}</p>
    </div>

    <a-modal
      title="使用说明"
      v-model="visible"
      :closable="false"
      class="mod-l8-alert-model"
      :bodyStyle="{'height': '420px', 'overflow-y': 'auto'}"
      centered
    >
      <template slot="footer">
        <a-button
          key="submit"
          type="primary"
          @click="handleOk"
        >确定</a-button>
      </template>
      <div
        style="text-align:left;"
        v-html="productDescription"
      ></div>
    </a-modal>

    <a-modal
      title="选择优惠券"
      v-model="couponPopUpVisible"
      :closable="false"
      class="mod-l8-alert-model p-20-model coupon-model"
    >
      <template v-if="!couponPopUpLoading">
        <a-radio-group  v-model="selectedCoupons[couponType].couponNumber" class="flex-hb-vc flex-hw" name="couponGroup" v-if="Array.isArray(couponList[couponType]) && couponList[couponType].length > 0">
          <div v-for="(coupon) in couponList[couponType]" :key="coupon.couponNumber">
              <CouponTicket
                :key="coupon.couponNumber"
                :data="coupon"
                :checked="coupon.checked"
              ></CouponTicket>
              <a-radio @click="chooseCoupon(coupon)" :disabled="!coupon.iallowUse || coupon.isChecked" :value="coupon.couponNumber" class="m-tb-10"></a-radio>
          </div>
        </a-radio-group>
        <span v-else>暂时没有可使用的优惠券。</span>
        <template slot="footer">
          <a-button
            key="submit"
            type="primary"
            @click="confirmCoupon()"
          >确定</a-button>
        </template>
      </template>
      <a-spin v-else/>
    </a-modal>
  </div>
</template>

<script>
import Vue from 'vue'
import '@/components/l8-icon'
import '@/assets/css/l8-model.less'
import { queryCoupon, queryAloneCoupon } from '@/apis/coupon'
import { getNetFareAmount } from '@/assets/js/util'
import ProductItem from './product-item.vue'
import ProductItinerary from './product-itinerary.vue'
import ProductItineraryPlus from './product-itinerary-plus.vue'
import ProductSeat from './product-seat.vue'
import CouponTicket from '@/components/coupon/coupon-ticket.vue'
import _ from 'lodash'
import moment from 'moment'
import { Checkbox, Radio, Form, Input, Modal, Spin } from 'ant-design-vue'
import '../css/products.less'
import getAppInfo from '@/utils/from'

Vue.use(Checkbox)
Vue.use(Radio)
Vue.use(Form)
Vue.use(Input)
Vue.use(Modal)
Vue.use(Spin)
const mainSettings = window.__MICRO_ROOT__ ?? {}

const normalProductType = [
  'luggage',
  'meal',
  'itinerary',
  'viphall',
  'seat'
]

const productTypeConvertMap = {
  luggage: 'LUGGAGE',
  meal: 'MEAL',
  insurance: 'INSURANCE',
  lugInsurance: 'INSURANCE',
  itinerary: 'ITINERARY',
  viphall: 'VIPHALL'
}

export default {
  props: {
    segment: {
      type: Object
    },
    current: {
      type: Object,
      default: function () {
        return {
          segmentIndex: 0,
          passengerIndex: 0
        }
      }
    },
    currentProduct: {
      type: String
    },
    cart: {
      type: Object
    },
    cartClone: {
      type: Object
    },
    isSelfAirline: Boolean,
    ifInternational: Boolean,
    productDesList: Array,
    insuranceDesList: Array,
    productBase: Object,
    noProductTipsConfig: {
      type: Array,
      default: () => {
        return []
      }
    },
    fetchLoading: {
      type: Boolean,
      default: false
    },
    itinerarys: Array
  },
  data () {
    return {
      visible: false,
      productDescription: '',

      // 优惠券列表数据
      couponList: {
        luggage: [],
        meal: [],
        guest: [],
        itinerary: []
      },
      couponPopUpVisible: false, // 优惠券弹窗是否可见
      couponPopUpLoading: false, // 优惠券弹窗是否加载
      couponType: '', // 当前产品的优惠券类型
      appInfo: getAppInfo(),
      airline: mainSettings.airline
    }
  },
  computed: {
    // 是否随票辅营
    isFollow () {
      const { cart } = this

      if (cart) {
        return true
      }

      return false
    },
    // 当前乘客信息
    passenger () {
      const { segment, current } = this

      if (!segment) {
        return {}
      }

      return segment.passengers[current.passengerIndex]
    },
    // 辅营产品
    products () {
      const { segment } = this

      if (!segment) {
        return {}
      }

      const products = {}
      normalProductType.forEach(key => {
        if (segment[key] && segment[key].length && segment[key][0].detail) {
          products[key] = segment[key][0].detail.productPrices
        } else {
          products[key] = []
        }
      })
      // 保险比较特殊，需要拆分成普通保险和行李险
      const insurances = []
      const lugInsurances = []

      if (segment.insurance && segment.insurance.length && segment.insurance[0].detail) {
        segment.insurance[0].detail.productPrices.forEach(product => {
          // NOTE: 8L - 保险拆分，仅 8L 需要拆分
          if (product.services[0].productName === '行李险' && mainSettings.airline === '8L') {
            lugInsurances.push(product)
          } else {
            insurances.push(product)
          }
        })
      }

      products.insurance = insurances
      products.lugInsurance = lugInsurances
      return products
    },
    // 已选择产品
    selectedProducts () {
      const { segment, current } = this
      if (!segment) {
        return {}
      }

      const selected = segment.passengers[current.passengerIndex].select || {}
      const selectedProducts = {}
      normalProductType.concat(
        [
          'insurance',
          'lugInsurance'
        ]
      ).forEach(key => {
        if (selected[key]) {
          selectedProducts[key] = selected[key]
        } else {
          selectedProducts[key] = []
        }
      })

      return selectedProducts
    },
    selectedCoupons () {
      const { segment, current } = this
      if (!segment) {
        return {}
      }

      const selected = segment.passengers[current.passengerIndex].select || {}
      const selectedCoupons = {}

      normalProductType.forEach(key => {
        if (selected[key]?.[0]?.coupons) {
          selectedCoupons[key] = selected[key][0].coupons
        } else {
          selectedCoupons[key] = {}
        }
      })

      // 这里没考虑保险的情况，如果保险也可以加优惠券需要处理
      return selectedCoupons
    },
    productDes () {
      const { productDesList } = this
      const productDes = {}
      if (productDesList) {
        productDesList.forEach(item => {
          item.value = encodeHtml(item.value)
          productDes[item.key] = item
        })
      }
      return productDes
    },
    insuranceDes () {
      const { insuranceDesList } = this
      const insuranceDes = {}
      if (insuranceDesList) {
        insuranceDesList.forEach(item => {
          insuranceDes[item.key] = item
        })
      }
      return insuranceDes
    },
    isEmpty () {
      const { products, isSelfAirline, fetchLoading, ifInternational, currentProduct, passenger } = this
      if (fetchLoading) return false
      if (!ifInternational) {
        return Object.values(products).findIndex(product => { return product.length !== 0 }) === -1 || !isSelfAirline
      } else {
        return products[currentProduct]?.length === 0 ||
        _.isEmpty(products) ||
        passenger.passengerType === 'INF' ||
        (currentProduct === 'seat' && passenger.passengerType === 'ADT' && passenger.hasAccompany)
      }
    }
  },
  watch: {
    current: {
      handler: function (val) {
        if (val) {
          normalProductType.forEach(key => {
            this.couponList[key] = []
          })
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    getProductEmptyText () {
      const { isEmpty, isFollow, isSelfAirline, ifInternational, appInfo, noProductTipsConfig } = this
      if (!isEmpty) {
        return
      }
      // isFollow - 随票/单独 isSelfAirline - 自营/互售 ifInternational - 国内/国际
      const defaultTextList = [
        {
          isFollow: true,
          ifInternational: false,
          isSelfAirline: false,
          text: `您选择的是非${appInfo.name}实际承运的航班，暂不支持购买增值产品。`
        },
        {
          isFollow: true,
          ifInternational: false,
          isSelfAirline: true,
          text: `您选择的航班暂无增值产品，请继续提交订单。`
        },
        {
          isFollow: false,
          isSelfAirline: true,
          ifInternational: false,
          text: `您选择的航班暂无增值产品。`
        },
        {
          isFollow: false,
          isSelfAirline: true,
          ifInternational: true,
          text: `您选择的航班暂无增值产品。`
        }
      ]
      const defaultText = !ifInternational ? '您选择的航班暂无增值产品，请继续提交订单。' : '您选择的品类暂无增值产品，请选择其他品类或提交订单。'
      const list = noProductTipsConfig?.length > 0 ? noProductTipsConfig : defaultTextList
      const text = list.find(item => { return item.isFollow === isFollow && item.isSelfAirline === isSelfAirline && item.ifInternational === ifInternational })?.text ?? defaultText
      return text
    },
    // 产品图片资源链接配置
    getAttachImageSrc (value) {
      return `//${location.host + value}`
    },
    hasProduct (name) {
      const { products } = this
      return products[name] && products[name].length
    },
    isCurrentProduct (name) {
      const { ifInternational, currentProduct } = this
      if (!ifInternational) {
        return true
      }
      return currentProduct === name
    },
    // 辅营产品选择
    onProductChange (type, value, isAdd, cartValue, couponEnable) {
      if (!isAdd && couponEnable) {
        // 移除产品时要移除优惠券
        const { selectedCoupons } = this
        if (selectedCoupons[type].couponNumber) {
          this.$emit('couponchange', selectedCoupons[type], type, false)
        }
      }

      this.$emit('select', type, value, isAdd, cartValue)
      // 选择产品后要请求优惠券
      if (couponEnable) {
        if (isAdd) {
          this.$nextTick(() => {
            this.getCouponList(type)
          })
        }
      } else {
        this.couponList[type] = []
      }
    },
    // 行程单修改
    onItineraryChange (value, product) {
      this.$emit('contactChange', {
        offerItemType: product.serviceType,
        detail: {
          offerItemId: product.offerItemId,
          productCode: product.productCode,
          productName: product.productName,
          price: getNetFareAmount(product.fareDetails),
          count: 1
        }
      }, value, [_.assignIn({}, product)])
    },
    // 产品说明弹窗
    onShowDesc (type) {
      const { productDes } = this

      this.productDescription = productDes[type] ? productDes[type].value : ''
      this.visible = true
    },
    // 产品说明弹窗
    handleOk () {
      this.visible = false
    },
    confirmCoupon () {
      this.couponPopUpVisible = false
    },
    // 优惠券选择
    chooseCoupon (couponItem) {
      const { couponType, selectedCoupons } = this
      const checked = couponItem.couponNumber !== selectedCoupons[couponType].couponNumber
      // if (selectedCoupons[couponType].couponNumber) {
      //   this.$emit('couponchange', selectedCoupons[couponType], couponType, false)
      // }
      if (checked) {
        // 移除产品时要移除优惠券
        const { selectedCoupons } = this
        if (selectedCoupons[couponType].couponNumber) {
          this.$emit('couponchange', selectedCoupons[couponType], couponType, false)
        }
      }

      this.$emit('couponchange', couponItem, couponType, checked)
    },
    showCouponList (type) {
      const { selectedProducts } = this
      if (!selectedProducts[type] || !selectedProducts[type].length) {
        this.$message.warning('请先选择相关辅营产品后，再选择优惠券')
        return false
      }
      this.couponPopUpVisible = true
      this.couponPopUpLoading = true
      this.getCouponList(type)
    },
    getCouponList (type) {
      const { itinerarys, segment, isFollow, selectedProducts, current } = this

      this.couponType = type
      this.couponList[type] = []
      if (isFollow) {
        // 随票
        const { cart } = this
        const params = {
          shoppingCartId: cart.shoppingCartId,
          couponType: productTypeConvertMap[type],
          offerItemIds: [],
          airlineCode: cart.offers[0].detail.itinerarys[0].orgDsts[0].supplier
        }

        // 携带产品参数
        if (selectedProducts[type] && selectedProducts[type].length) {
          params.offerItemIds = selectedProducts[type].map(function (item) {
            return {
              offerItemId: item.offerItemId
            }
          })
        }
        queryCoupon(params).then(data => {
          const list = _.orderBy(data, ['iallowUse', 'couponAmount', 'validEndDate', 'couponNumber'], ['desc', 'desc', 'asc', 'asc'])
          this.judgeCouponIsChecked(itinerarys, current, type, list)
          this.couponList[type] = list
          this.$emit('couponlistchange', list, type)
          this.couponPopUpLoading = false
        }).catch(err => {
          this.loading = false
          this.$message.error(err.message || '网络异常，请稍后再试！')
        })
      } else {
        // 单独
        const [passengers, segmentInfos] = [[], []]
        passengers.push({
          markFare: getNetFareAmount(selectedProducts[type][0].fareDetails), // 票面价
          passegerName: segment.passengerName, // 旅客姓名
          passegerType: segment.passengerType // 旅客类型
        })
        segmentInfos.push({
          flightNo: segment.flightNo, // 航班号
          depCode: segment.depCode, // 离港城市
          arrCode: segment.arrCode, // 到港城市
          productCode: segment.productCode, // 产品代码
          depTime: moment(segment.depTime).format('YYYY-MM-DD'), // 离港时间
          bookTime: moment().format('YYYY-MM-DD'), // 预订时间
          passengers: passengers
        })
        const params = {
          airlineCode: mainSettings.airline,
          channel: 'NN',
          couponType: productTypeConvertMap[type],
          segmentInfos: segmentInfos
        }
        queryAloneCoupon(params).then(data => {
          const list = _.orderBy(data, ['iallowUse', 'couponAmount', 'validEndDate', 'couponNumber'], ['desc', 'desc', 'asc', 'asc'])
          this.judgeCouponIsChecked(itinerarys, current, type, list)
          this.couponList[type] = list
          this.couponPopUpLoading = false
        }).catch(err => {
          this.loading = false
          this.$message.error(err.message || '网络异常，请稍后再试！')
        })
      }
    },
    // 获取可用优惠券数量
    getCouponNumber (type) {
      const { couponList } = this

      return couponList[type] ? couponList[type].filter(item => item.iallowUse).length : 0
    },
    // 判断某优惠券是否被其他行程使用，如果已被使用则添加标识isChecked
    judgeCouponIsChecked (itinerarys, current, type, list) {
      for (let i = 0; i < itinerarys.length; i++) {
        const passengers = itinerarys[i].passengers || []
        for (let j = 0; j < passengers.length; j++) {
          if (i === current.segmentIndex && j === current.passengerIndex) {
            continue
          }
          const select = passengers[j].select || {}
          if (select[type] && select[type].length) {
            for (let k = 0; k < list.length; k++) {
              const item = list[k]
              if (select[type][0].coupons && select[type][0].coupons.couponNumber === item.couponNumber) {
                item.isChecked = true
              }
            }
          }
        }
      }
    }
  },
  components: {
    ProductItem,
    ProductItinerary,
    ProductItineraryPlus,
    ProductSeat,
    CouponTicket
  }
}
function encodeHtml (value) {
  return value.replace(/\n/g, '<br/>').replace(/\s{1}/g, '&nbsp;&nbsp;')
}
</script>
